import {
  ComponentType,
  Context,
  FontWeight,
  Direction,
  Size,
  VisualStyle,
} from 'data-types-config';
import type { InteractiveArchetypeProps } from './InteractiveArchetype.types';

export const interactiveArchetypeDefaults: Partial<InteractiveArchetypeProps> = {
  ariaLabel: '',
  componentType: ComponentType.Interactive,
  isDisabled: false,
  text: '',
  context: Context.None,
  fontWeight: FontWeight.Normal,
  direction: Direction.None,
  size: Size.Medium,
  isBlock: false,
  visualStyle: VisualStyle.Default,
  isVisible: true,
};
